"use client";

import { PRODUCT_GRID_SIZES } from "@/components/features/listings/image-sizes";
import { ProductCardView } from "@/components/features/listings/product-card-view";
import { cn } from "@/lib/utils";
import { catalogueGridClassName } from "@/components/listing/browse/catalogue-shell";
import type { BrowserListing } from "./listing-filters";

export function ListingResultsGrid({
  cards,
  hasMap,
  highlightedId,
  onHoverCard,
  firstIsLcp,
}: {
  cards: readonly BrowserListing[];
  hasMap: boolean;
  highlightedId: string | null;
  onHoverCard: (id: string | null) => void;
  firstIsLcp: boolean;
}) {
  return (
    <ul className={cn("ph-no-capture", catalogueGridClassName(hasMap))}>
      {cards.map((card, index) => (
        <li
          key={card.id}
          data-highlighted={card.id === highlightedId ? "" : undefined}
          className={cn(
            "min-w-0 rounded-lg transition-shadow duration-150 max-md:rounded-none",
            "data-[highlighted]:ring-2 data-[highlighted]:ring-action-fill data-[highlighted]:ring-offset-2 data-[highlighted]:ring-offset-background",
          )}
          onMouseEnter={() => onHoverCard(card.id)}
          onMouseLeave={() => onHoverCard(null)}
          onFocus={() => onHoverCard(card.id)}
          onBlur={() => onHoverCard(null)}
        >
          <ProductCardView
            display={card.card}
            priority={firstIsLcp && index === 0}
            sizes={PRODUCT_GRID_SIZES}
            phoneRow
          />
        </li>
      ))}
    </ul>
  );
}
